export default __webpack_public_path__ + "static/media/nathan_profile_pic.b07d6a63.png";